<template>
    <div>
        <b-modal
            v-model="showModal" 
            title="Editar senha do usuário" 
            @shown="onModalShown"
            hide-footer 
            centered 
        >
            <div class="bg-white border rounded-lg p-2 d-flex align-items-center mb-3">
                <div class="bg-light border rounded p-2 mr-2" aria-hidden="true">
                    <i class="fas fa-user-lock"></i>
                </div>

                <div>
                    <h6 class="mb-0 font-weight-bold">Defina uma nova senha</h6>
                    <small> Use pelo menos <strong>8 caracteres</strong>, com <strong>letra</strong> e <strong>número</strong>.</small>
                </div>
            </div>

            <el-form 
                :model="payload" 
                ref="userUpdatePasswordForm" 
                label-position="top" 
                status-icon 
                :rules="rules"
            > 
                <el-row :gutter="12">

                    <!-- Senha -->
                    <el-col>
                        <el-form-item prop="password">
                            <label>Senha</label>
                            <el-input
                                type="password"
                                v-model="payload.password" 
                                placeholder="Digite a nova senha"
                                :disabled="isLoading"
                                autocomplete="off"
                                show-password
                            />
                        </el-form-item>
                    </el-col>

                    <!-- Confirmar Senha -->
                    <el-col>
                        <el-form-item prop="password_confirmation">
                            <label>Confirmar senha</label>
                            <el-input
                                type="password"
                                v-model="payload.password_confirmation" 
                                placeholder="Confirme a nova senha"
                                :disabled="isLoading"
                                autocomplete="off"
                                show-password
                            />
                        </el-form-item>
                    </el-col>


                    <!-- Resetar senha -->
                    <el-col>
                        <el-form-item prop="status">
                            <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                <el-switch v-model="payload.reset_password" />
                                Alterar senha no próximo acesso?
                            </div>
                        </el-form-item>

                        <div v-if="payload.reset_password" class="bg-white border rounded-lg p-2 d-flex align-items-center mb-3">
                            <div class="bg-light border rounded p-2 mr-2" aria-hidden="true">
                                <i class="el-icon-warning-outline"></i> 
                            </div>
                            <small>A senha será alterada imediatamente, e o usuário precisará usar a nova senha para acessar o sistema.</small>
                        </div>
                    </el-col>

                    <!-- Actions -->
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-form-item>
                                <el-button 
                                    type="danger"
                                    plain
                                    :disabled="isLoading"
                                    @click="() => {
                                        toggleModal();
                                        resetForm();
                                    }"
                                >
                                    Cancelar
                                </el-button>

                                <el-button 
                                    type="primary"
                                    :disabled="isLoading || userId == null"
                                    @click="onSubmit"
                                >
                                    Salvar
                                    <i v-if="isLoading" class="el-icon-loading"></i>
                                    <i class="fas fa-check-circle"></i>
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </b-modal>
    </div>
</template>
<script>
    // Components
    import {
        Message,
        Loading,
        Row,
        Col,
        Dialog,
        Button,
        Input,
        Empty,
        Notification,
        Form, 
        FormItem,
        Select,
        Option,
        Switch,
    } from "element-ui";

    // Schema
    import { validatePass, validateMatchPass } from "@/schemas/generalSchema"

    //Api
    import { UserApi } from "@/api/User/UserApi";

    const userApi = new UserApi();

    export default { 
        data() {
            return {
                userId: null,
                payload: {
                    password: null,
                    password_confirmation: null,
                    reset_password: false
                },
                showModal: false,
                isLoading: false,
                rules: {
                    password: [
                        { required: true, message: 'Por favor digite a nova senha' },
                    ],
                    password_confirmation: [
                        { required: true, message: 'Por favor digite a senha novamente' },
                    ],
                },
            }
        },
        methods: {
            async handleEdit(id) {
                this.userId = id;

                this.toggleModal();
            },
            async onSubmit() {
                this.$refs.userUpdatePasswordForm.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading = true;

                    await userApi.updatePassword(this.payload, this.userId)
                        .then(() => {
                            Notification.success({
                                title: 'Sucesso',
                                message: 'A senha do usuário foi atualizada com sucesso!'
                            });
                        }).catch((error) => {
                            Notification.error({
                                title: 'Erro',
                                message: 'Não foi possível atualizar a senha do usuário!'
                            });
                        }).finally(() => {
                            this.isLoading = false;
                            this.toggleModal();
                            this.resetForm();
                        });
                })
            },
            toggleModal() {
                this.showModal = !this.showModal;
            },
            onModalShown() {
                if (this.$refs.userUpdatePasswordForm) {
                    this.resetForm();
                }
            },
            resetForm() {
                this.$refs.userUpdatePasswordForm.resetFields();
            },
        },
        created() {
            this.rules.password.push({ validator: validatePass(this.payload), trigger: 'blur' })
            this.rules.password_confirmation.push({validator: validateMatchPass(this.payload), trigger: 'blur' })
        },
        components: {
            [Message.name]: Message,
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Dialog.name]: Dialog,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [Switch.name]: Switch,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/User/UserEditPasswordModal.vue